import React, { useEffect } from 'react';
import './InvalidPhonePopup.module.scss';

export const InvalidPhonePopup = ({ onClose, autoDismiss = false, autoDismissDelay = 5000 }) => {
  useEffect(() => {
    if (!autoDismiss) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, autoDismissDelay);

    return () => clearTimeout(timer);
  }, [autoDismiss, autoDismissDelay, onClose]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleBackdropClick = () => {
    onClose?.();
  };

  const handleInnerClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className="invalid__phone__popup"
      onClick={handleBackdropClick}
    >
      <div
        className="box"
        onClick={handleInnerClick}
        role="dialog"
        aria-modal="true"
        aria-labelledby="invalid-phone-title"
        aria-describedby="invalid-phone-desc"
      >

        <div
          id="invalid-phone-title"
          className="title"
        >
          <span>Nomor Anda tidak valid</span>
        </div>

        <div
          id="invalid-phone-desc"
          className="subtitle"
        >
          <span>Silakan masukkan nomor telepon aktif Anda</span>
        </div>

        <img
          src="/static/images/invalid-phone-number.png"
          alt="Ilustrasi nomor telepon tidak valid"
          width={250}
          height={300}
        />

        <button
          type="button"
          onClick={onClose}
        >
          <span>Saya paham</span>
        </button>
      </div>
    </div>
  );
};

export default InvalidPhonePopup;
